
import Vue from "vue";
import API from "@/api/API";

export default Vue.extend({
  name: "PaymentSuccess",

  data: () => ({
    timer: null as any,
    usmfLogo: require("@/assets/images/usmf-logo.png"),
  }),

  async mounted() {
    await this.checkEmailToken();
    this.timer = setTimeout(() => {
      this.toMain();
    }, 30000);
  },

  methods: {
    async checkEmailToken(): Promise<void> {
      try {
        const credentials = await API.auth().checkEmailToken(
          this.$route.params.token
        );
        await this.$store.dispatch("authentication/login", credentials);
        await this.$store.dispatch("user/set", credentials.user);
      } catch (e) {
        await this.$router.push("/auth/email-expired");
      }
    },
    toMain() {
      clearTimeout(this.timer);
      this.$router.push("/");
    },
  },
});
